
import { Image } from "element-ui"
import { formatImgUrl } from "../../utils/utils"
import { getUserIdAndLabel } from "@/utils/userId"
// 将数组数据分行
function arrayToRow(arr, row) {
  if (!arr) return []
  const result = []
  let output = []
  for (let i = 0; i < arr.length; i++) {
    arr[i].index = i % row
    if (i % row === 0 && i !== 0) {
      result.push([...output])
      output = [arr[i]]
    } else {
      output.push(arr[i])
    }
  }
  result.push([...output])
  return result
}
export default {
  name: "HorizontalMiniIconMenu",
  components: {
    [Image.name]: Image
  },
  props: {
    dataList: {
      type: Array,
      default: () => [
        // {
        //   remark: "",
        //   spImgUrl: ""
        // },
      ]
    }
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    dataList: {
      handler(newVal) {
        if (!newVal) return
        this.list = arrayToRow(newVal, 5)
      },
      immediate: true
    }
  },
  methods: {
    handleImageClick(item, index) {
      if (item.uclid) {
        const { userId, customLabel } = getUserIdAndLabel()
        this.$onlineSalesSdk.registerAdClickEvent({
          cliUbid: userId,
          "f.custom_label_1": customLabel,
          uclid: item.uclid
        })
      }
    },
    handleImgLoad(item, event) {
      // 图片加载成功
      if (item.uclid) {
        const { userId, customLabel } = getUserIdAndLabel()
        this.$onlineSalesSdk.registerAdImpressionEvent({
          cliUbid: userId,
          "f.custom_label_1": customLabel,
          uclid: item.uclid
        })
      }
    },
    formatImgUrl,
    formatLinkTo(item) {
      if (item.itemType === 15) {
        return {
          path: "/banner_home",
          query: {
            storeId: item.storeId
          }
        }
      }
      return item.resource
    }
  }
}
